import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option:
      "a) 20x mais rapidez na resposta, 80% de redução de respostas errôneas e 100% ganho de eficiência",
    correct: true,
  },
  {
    option:
      "b) 5x mais rapidez na resposta, 20% de redução de resposta errôneas e sem ganho de eficiência",
    correct: false,
  },
  {
    option:
      "c) 50x mais rapidez na resposta, 100% de redução de resposta errôneas e 20% ganho de eficiência",
    correct: false,
  },
  {
    option:
      "d) 10X mais rapidez na resposta, 25% de redução de respostas errôneas e 1505 ganho de eficiência",
    correct: false,
  },
  {
    option: "e) Não há mensuração de resultados ainda",
    correct: false,
  },
];

export default function Question12(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question12: {
          title:
            "Quais os principais resultados experimentados no case SAI CYBER?",
          option: option.option,
          correct: option.correct,
          order: 12
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t("Quais os principais resultados experimentados no case SAI CYBER?")}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
